import { render, staticRenderFns } from "./kpiData.vue?vue&type=template&id=ed71b72c&scoped=true&"
import script from "./kpiData.vue?vue&type=script&lang=js&"
export * from "./kpiData.vue?vue&type=script&lang=js&"
import style0 from "./kpiData.vue?vue&type=style&index=0&id=ed71b72c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed71b72c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed71b72c')) {
      api.createRecord('ed71b72c', component.options)
    } else {
      api.reload('ed71b72c', component.options)
    }
    module.hot.accept("./kpiData.vue?vue&type=template&id=ed71b72c&scoped=true&", function () {
      api.rerender('ed71b72c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/GuideChildren/kpiData.vue"
export default component.exports